import { ApiError } from '../api/types';

// `error` first: packager endpoints send { error, status } where status is the
// package's current status. DRF field errors arrive as lists ({ status: ["..."] }).
const MESSAGE_KEYS = ['error', 'status', 'detail', 'message'];

const asMessage = (value: unknown): string | null => {
  if (typeof value === 'string') return value;
  if (Array.isArray(value) && typeof value[0] === 'string') return value[0];
  return null;
};

export const extractApiError = (error: unknown, fallback = 'Something went wrong.'): string => {
  if (!(error instanceof Error)) return fallback;
  const data = (error as ApiError).responseData;
  if (data && typeof data === 'object') {
    for (const key of MESSAGE_KEYS) {
      const message = asMessage((data as Record<string, unknown>)[key]);
      if (message) return message;
    }
  }
  return error.message || fallback;
};
